import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material'
import { type FC, useState } from 'react'
import { useHistory } from 'react-router-dom'

interface Props {
  onCancel: () => void
}

const SelectGridVariableModal: FC<Props> = ({ onCancel }) => {
  const history = useHistory()
  const [hasVariables, setHasVariables] = useState(false)

  return (
    <Dialog open onClose={onCancel}>
      <DialogTitle>取り込み項目の設定</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography variant="body2">
            表形式のひな形では、日々変動する項目を「取り込み項目」として設定することが出来ます。
          </Typography>
          <RadioGroup
            value={hasVariables ? 'true' : 'false'}
            onChange={e => setHasVariables(e.target.value === 'true')}
          >
            <FormControlLabel
              value="false"
              control={<Radio />}
              label={
                <>
                  取り込み項目 <strong>なし</strong> で設定
                </>
              }
            />
            <FormControlLabel
              value="true"
              control={<Radio />}
              label={
                <>
                  取り込み項目 <strong>あり</strong> で設定
                </>
              }
            />
          </RadioGroup>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onCancel}>
          キャンセル
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            history.push({
              pathname: '/templates/pages/addGridTemplate',
              search: `hasVariables=${hasVariables}`,
            })
          }}
        >
          作成
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SelectGridVariableModal
